// Axios configuration to handle API base URL
import axios from 'axios';

const API_BASE_URL = (() => {
  const explicit = process.env.REACT_APP_API_URL;
  if (explicit) {
    return explicit.replace(/\/api$/, ''); // Remove trailing /api if present
  }

  if (typeof window !== 'undefined') {
    const host = window.location.hostname?.toLowerCase();
    const isLocal =
      host === 'localhost' ||
      host === '127.0.0.1' ||
      host === '::1';
    if (isLocal) return 'http://localhost:5000';
  }

  return 'const API_BASE_URL = "https://pathmarkr-alb-1917965496.us-east-1.elb.amazonaws.com";';
})();

// Add request interceptor to prepend base URL to relative /api/ URLs
axios.interceptors.request.use(
  (config) => {
    // If URL starts with /api/, prepend the API base URL
    if (config.url && config.url.startsWith('/api/')) {
      config.url = `${API_BASE_URL}${config.url}`;
    }

    // Add authentication header if token exists
    const token = sessionStorage.getItem('token');
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // changed by me — bypass ngrok browser interstitial warning page for local dev
    // Only for requests to our backend — adding it to third-party URLs forces CORS preflights they reject
    const fullUrl = `${config.baseURL || ''}${config.url || ''}`;
    if (API_BASE_URL.includes('ngrok') && (fullUrl.startsWith(API_BASE_URL) || config.url?.startsWith(API_BASE_URL))) {
      config.headers['ngrok-skip-browser-warning'] = 'true';
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;
